jQuery(function () {
  // Whenever any of these checkboxes is clicked
  let globalArray = [];
  let imageUrl = 'https://cdn.shopify.com/s/files/1/0569/6104/0451/files/';
  jQuery(document).on('click',"button.single_wood_chk", function () {
    // Loop all these checkboxes which are checked
    var dataId = jQuery(this).val();
    var productHandle = jQuery(this).data('handle');
    var productVendor = jQuery(this).attr('product-vendor');
    //jQuery('.products-cart-items').addClass('hide'); 
    jQuery('.'+dataId+'_wood_product').removeClass('hide'); 
    jQuery('.normal_all_chk').addClass('hide');
    jQuery('.bulk_edit').removeClass('hide');
    jQuery('.normal_edit').addClass('hide'); 
    jQuery('.single_wood_chk').removeClass("checked");
    jQuery('.variant-error').text('');
    jQuery(this).addClass("checked");
    if(productHandle!=""){
        jQuery.ajax({
            url: '/products/' + productHandle + '.js',
            type: 'GET',
            dataType: 'json',
            success: function(product) {
                var optionsdata = product.options;
                var variantOption=product.variants;
                if(variantOption.length>0){
                  for(var i=0;i<variantOption.length;i++){
                    var mainopt = variantOption[i].option1.replace(' ','-');
                    mainopt = mainopt.toLowerCase();
                    var subopt = variantOption[i].option2.replace(' ','-');
                    if(!globalArray[mainopt]){
                      globalArray[mainopt] = [];
                    }
                    globalArray[mainopt].push(subopt);
                  }
                }
                $('.variant-product-show').html(''); // Clear previous data
                var swatchColor='';
                var flagswatch=0;
                var indexfirst=0;
                var firstVariant='';
                var woodVariant = jQuery('.'+dataId+'_wood_product').find('[data-option="wood_species"]').data('variant');
                var colorVariant = jQuery('.'+dataId+'_wood_product').find('[data-option="stain_color"]').data('variant');
                $.each(optionsdata, function(index, options) {
                    var colorstyle="";
                    if(productVendor=='grandcellar' && options.name=='Stain Color'){
                      colorstyle='display:none;'
                    }
                    swatchColor+='<div class="variant--item" style="'+colorstyle+'">';
                    if(options.name=='Wood Species' || options.name=='Stain Color'){
                      swatchColor+='<label class="add-note"> '+options.name+': </label>';
                    }
                    swatchColor+='<div class="variant--wrapper">';
                    var optionFirst = options.name.toLowerCase().replace(/[^A-Za-z0-9]/g, '-');
                    for(var f=0;f<options.values.length;f++){
                        var optionvalue = options.values[f].toLowerCase().replace(/[^a-z0-9]/g, '-');
                        var optionvalue1 = options.values[f];
                        if(indexfirst==0){
                          firstVariant=options.values[f].toLowerCase().replace(/[^a-z0-9]/g, '-');
                        }
                        var optimg = optionvalue1.replace(/[^a-zA-z0-9]/g, '-');
                        if(options.name=='Wood Species' || options.name=='Stain Color'){
                            var imgstr='-unstained';
                            var attributestr='';
                            var checkClass='';
                            if(options.name=='Stain Color'){
                              attributestr = 'data-img-value="'+optimg+'"';
                              if(optionvalue1==colorVariant){
                                checkClass='checked';
                              }
                            }else if(options.name=='Wood Species'){
                              if(optionvalue1==woodVariant){
                                checkClass='checked';
                              }
                            }
                            swatchColor+='<div class="variant--input variant--input-item variant-'+optionFirst+' '+checkClass+'" data-value2="'+optionvalue1+'" data-value="'+optionvalue+'" '+attributestr+'>';
                            swatchColor+='<input id="wood-species-1" type="radio" name="'+options.name+'" value="'+optionvalue+'" '+checkClass+' data-value2="'+optionvalue1+'">';
                            swatchColor+='<label class="variant--input-label" for="wood-species-1">';
                            swatchColor+='<img src="https://cdn.shopify.com/s/files/1/0569/6104/0451/files/'+optionvalue+imgstr+'.jpg?v=5075336275002478359"></label>';
                            swatchColor+='<div class="tool-tip">'+optionvalue1+'</div></div>';
                        }else{
                           var titleVar=options.values[f].toLowerCase().replace(/\s+/g, '_');
                           var titleVar1=options.values[f].toLowerCase().replace(/\s+/g, '_');
                           titleVar1=titleVar1.replace('without','with');
                           if(flagswatch==0){
                             var checkedStr='';
                             var selectedEditProduct = dataId+'_wood_product';
                             jQuery('.'+selectedEditProduct+' .varinat-selected').each(function(){
                               if(jQuery(this).data('option')!='wood_species' && jQuery(this).data('option')!='stain_color'){
                                  var optionValue = jQuery(this).attr('data-variant');
                                  if(optionValue.includes('without')==false){
                                    checkedStr="checked";
                                  }
                               }
                            });
                            var stainStr = options.name;
                        
                            swatchColor+='<div class="variant--item variant--item-check"><label class="add-note">';
                            swatchColor+='<input id="sealant-check" type="checkbox" '+checkedStr+' name="clear coat" value="with_clear_coat" data-value1="'+titleVar1+'" data-value="'+titleVar+'">'+stainStr+'</label></div>';
                           }
                           flagswatch++;
                        }
                      mainopt='';
                      indexfirst++;
                    }
                    swatchColor+='</div></div>';
                    $('.variant-product-show').html(swatchColor);
                    
                });
               imageVariantionWise(firstVariant,globalArray)
            },
            error: function() {
                $('#variant-data').html('<p>Unable to fetch variant data.</p>');
            }
        });
    }
  });
  
  jQuery(".wood_pro_btn").click(function () {
    if(jQuery(this).hasClass("normal_edit_chk")){
      jQuery(this).addClass('bulk_edit_chk');
      jQuery(this).removeClass('normal_edit_chk');

      jQuery('.normal_all_chk').addClass('hide');

      jQuery('.bulk_edit').removeClass('hide');
      jQuery('.normal_edit').addClass('hide');

      jQuery('.cart__item ').addClass('hide'); 

      jQuery('.single_wood_chk_main').addClass('hide');
      jQuery("input.single_wood_chk:checked").each(function(){
        var dataId = jQuery(this).val();
        jQuery('.'+dataId+'_wood_product').removeClass('hide'); 
      });
    }
    else{
      jQuery('.normal_all_chk').removeClass('hide');
      jQuery(this).removeClass('bulk_edit_chk');
      jQuery(this).addClass('normal_edit_chk');

      jQuery('.bulk_edit').addClass('hide');
      jQuery('.normal_edit').removeClass('hide');

      jQuery('.cart__item ').removeClass('hide');
      jQuery('.single_wood_chk_main').removeClass('hide');
      jQuery('.cart__item--variants').removeClass('hide');

      jQuery('.cart__price').removeClass('hide');
      jQuery('.wood__price').addClass('hide');
      jQuery('.cart__item--variants_wood').addClass('hide');      
    }
  });

  function recalculateWoodPrice(){
    jQuery('.cart-loading').show();
    jQuery('.single_wood_chk.checked').parent().parent().parent().parent().find('.variant-error').remove();
    var dataId = jQuery('.single_wood_chk.checked').val();
    var option1 = jQuery('.variant-wood-species.checked');
    var option2 = $(".variant-stain-color.checked");
    var option3 = $("input[name='clear coat']:checked");

    var option1valCap = option1.attr('data-value2');
    var option2valCap = option2.attr('data-value2');
    var option3valCap = '';

    
    var option1val = option1.attr('data-value').replace('-', '_');
    var option2val = option2.attr('data-value').replace('-', '_');
    var option3val = option3.val();
    if (typeof option3val === "undefined") {
      option3val = $("input[name='clear coat']").attr('data-value');
      option3valCap = 'Without Clear Coat';
    }else{
      option3val = $("input[name='clear coat']").attr('data-value1');
      option3valCap = 'With Clear Coat';
    }
    option2val = option2val.replace(/\s+/g, '_').toLowerCase();
    //console.log("===>"+dataId+'_'+option1val+'_'+option2val+'_'+option3val);
    var variantId = jQuery('#'+dataId+'_'+option1val+'_'+option2val+'_'+option3val).val();
    //console.log("variantId===>"+variantId);
    
    if (typeof variantId === "undefined") {
      jQuery('.single_wood_chk.checked').parent().parent().parent().parent().find('.cart__item-sub').before("<div class='variant-error'>You can't select "+option1valCap+" for this product.</div>");
    }
    else{
      jQuery('.single_wood_chk.checked').parent().parent().parent().parent().find('.cart__price').addClass('hide');
      jQuery('.single_wood_chk.checked').parent().parent().parent().parent().find('.cart__item--variants').addClass('hide');
      
      //console.log("variantId===>"+variantId);
      var variantPrice = jQuery('#'+dataId+'_'+option1val+'_'+option2val+'_'+option3val).data('price');
      console.log("variantPrice===>"+variantPrice);
      var variantPriceArr = variantPrice.split('.');

      jQuery('.'+dataId+'_wood_product_price').removeClass('hide');
      jQuery('.'+dataId+'_wood_product_price > span:first').html(variantPriceArr[0]+'<sup>'+variantPriceArr[1]+'</sup>');
      jQuery('.'+dataId+'_wood_product_price > span.visually-hidden').html(variantPrice);

      jQuery('.'+dataId+'_cart__item--variants').removeClass('hide');
      jQuery('.'+dataId+'_wood_species > p').html(option1valCap);
      jQuery('.'+dataId+'_stain_color > p').html(option2valCap);
      jQuery('.'+dataId+'_clear_coat_sealant > p').html(option3valCap);

      jQuery('#'+dataId+'_new_variant').val(variantId);  
    }
    setTimeout(function(){
      jQuery('.cart-loading').hide();
    },1000);
  }
  
  $(document).on("click",".variant-wood-species",function(e){
      e.preventDefault();
      jQuery('.variant-wood-species').each(function(){
          jQuery(this).find('[type="radio"]').removeAttr("checked");
      });
      var variantName  = jQuery(this).data('value');
      jQuery('.variant-wood-species').removeClass("checked");
      jQuery(this).addClass("checked");
      imageVariantionWise(variantName,globalArray);
      jQuery(this).find('[type="radio"]').attr("checked",true);
      recalculateWoodPrice();
  });
  $(document).on("click",".variant-stain-color",function(e){
      e.preventDefault();
      jQuery('.variant-stain-color').each(function(){
          jQuery(this).find('[type="radio"]').removeAttr("checked");
      });
      jQuery(this).find('[type="radio"]').attr("checked",true);
      jQuery('.variant-stain-color').removeClass("checked");
      jQuery(this).addClass("checked");
      recalculateWoodPrice();
  });
  $(document).on("change","input[type=checkbox][name='clear coat']",function(e) {
      e.preventDefault();
      recalculateWoodPrice();
      var coatString='Without';
      if(jQuery(this).is(":checked")){
        coatString='With';
      }
      var editProductId = jQuery('.single_wood_chk.checked').val();
      if(editProductId!="" && editProductId!=undefined){
        jQuery('.'+editProductId+'_wood_product'+' .varinat-selected').each(function(){
          if(jQuery(this).data('option')!='wood_species' && jQuery(this).data('option')!='stain_color'){
            var coatText = jQuery(this).find('.coat-text-var').text();
            if(coatText.includes('without')==false){
                coatText = coatText.replace('with','without');
            }else{
                coatText = coatText.replace('without','with');
            }
            jQuery(this).find('.coat-text-var').text(coatText);
          }
        });
      }
  });

  function imageVariantionWise(variantName,globalArray){
    for(var f=0;f<globalArray[variantName].length;f++){
      var lowercasecolor = globalArray[variantName][f].toLowerCase();
      var setValue = globalArray[variantName][f].replace(' ','-');
      var imgArrName = lowercasecolor.split('-');
      lowercasecolor = lowercasecolor.replace('-'+imgArrName[1],'');
      var imageSrc = imageUrl+variantName+'-'+lowercasecolor+'.jpg';
      jQuery('[data-img-value="'+globalArray[variantName][f]+'"]').find('img').attr('src',imageSrc);
    }
  }
  
  jQuery(".recalculate_wood_price").click(function () {
    jQuery('.cart-loading').show();
    jQuery("input.single_wood_chk:checked").each(function(){
      jQuery(this).parent().parent().parent().parent().find('.variant-error').remove();
      var dataId = jQuery(this).val();
      var option1 = jQuery('.variant-wood-species.checked');
      var option2 = $(".variant-stain-color.checked");
      var option3 = $("input[name='clear coat']:checked");

      var option1valCap = option1.attr('data-value2');
      var option2valCap = option2.attr('data-value2');
      var option3valCap = 'With Clear Coat';

      var option1val = option1.attr('data-value').replace('-', '_');
      var option2val = option2.attr('data-value').replace('-', '_');
      var option3val = option3.val();
      if (typeof option3val === "undefined") {
        option3val = $("input[name='clear coat']").attr('data-value');
        option3valCap = 'Without Clear Coat';
      }else{
        option3val = $("input[name='clear coat']").attr('data-value1');
      }
      option2val = option2val.replace(/\s+/g, '_').toLowerCase();
      console.log("===>"+dataId+'_'+option1val+'_'+option2val+'_'+option3val);
      var variantId = jQuery('#'+dataId+'_'+option1val+'_'+option2val+'_'+option3val).val();
      console.log("variantId===>"+variantId);
      jQuery('#'+dataId+'_new_variant').val('');
      if (typeof variantId === "undefined") {
        jQuery(this).parent().parent().parent().parent().find('.cart__item-sub').before("<div class='variant-error'>You can't select "+option1valCap+" for this product.</div>");
      }
      else{
        jQuery(this).parent().parent().parent().parent().find('.cart__price').addClass('hide');
        jQuery(this).parent().parent().parent().parent().find('.cart__item--variants').addClass('hide');
        
        console.log("variantId===>"+variantId);
        var variantPrice = jQuery('#'+dataId+'_'+option1val+'_'+option2val+'_'+option3val).data('price');
        console.log("variantPrice===>"+variantPrice);
        var variantPriceArr = variantPrice.split('.');
  
        jQuery('.'+dataId+'_wood_product_price').removeClass('hide');
        jQuery('.'+dataId+'_wood_product_price > span:first').html(variantPriceArr[0]+'<sup>'+variantPriceArr[1]+'</sup>');
        jQuery('.'+dataId+'_wood_product_price > span.visually-hidden').html(variantPrice);
  
        jQuery('.'+dataId+'_cart__item--variants').removeClass('hide');
        jQuery('.'+dataId+'_wood_species > p').html(option1valCap);
        jQuery('.'+dataId+'_stain_color > p').html(option2valCap);
        jQuery('.'+dataId+'_clear_coat_sealant > p').html(option3valCap);
  
        jQuery('#'+dataId+'_new_variant').val(variantId);  
      }    
    });
    setTimeout(function(){
      jQuery('.cart-loading').hide();
    },1000);
  });

   jQuery(".udpate_wood_price").click(function () {
     var udpateCartArr = [];
     var newCartArr = [];
     var formData = { updates: {} };
     var dataId = jQuery('.single_wood_chk.checked').val();
     var dataIdArr = dataId.split('_');
     var newDataId = dataId.replace('_',':');
     var newVariantId = jQuery('#'+dataId+'_new_variant').val();

     if(newVariantId == ''){
        var option1 = $("input[type='radio'][name='Wood Species']:checked");
        var option2 = $("input[type='radio'][name='Stain Color']:checked");
        var option3 = $("input[name='clear coat']:checked");
  
        var option1valCap = option1.attr('data-value2');
        var option2valCap = option2.attr('data-value2');
        var option3valCap = 'With Clear Coat';
  
        var option1val = option1.val();
        var option2val = option2.val();
        var option3val = option3.val();
        if (typeof option3val === "undefined") {
          option3val = 'without_clear_coat';
          option3valCap = 'Without Clear Coat';
        }
        option2val = option2val.replace(/\s+/g, '_').toLowerCase();
        console.log(dataId+'_'+option1val+'_'+option2val+'_'+option3val);
        var newVariantId = jQuery('#'+dataId+'_'+option1val+'_'+option2val+'_'+option3val).val();
        if (typeof newVariantId === "undefined") {
          newVariantId = '';
          //jQuery(this).parent().parent().parent().parent().find('.cart__item-sub').before("<div class='variant-error'>You can't select "+option1valCap+" for this product.</div>");
        }
      }

      if(newVariantId != ''){
        var quantity = jQuery('#cart_updates_'+dataId).val();
  
        var tempArr = [];
        var tempArr1 = [];
        
        var tempArr1 = {'id':newDataId,'quantity': 0};
        udpateCartArr.push(tempArr1);
  
        formData.updates[parseInt(dataIdArr[0])] = 0;
         
        var tempArr = {'id':newVariantId,'quantity': quantity};
        newCartArr.push(tempArr); 
      }
     if(udpateCartArr.length > 0){
      jQuery('.cart-loading').show();
      jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: formData,
        dataType: 'json',
        success: function(data) {
          //jQuery('.cart-loading').hide();
          console.log('success', data);
        },
        error: function (request, status, error) {
          
        }
      });
     }
     if(newCartArr.length > 0){
       jQuery('.cart-loading').show();
      setTimeout(function () {
        let formData = {
         'items': newCartArr
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          //jQuery('.cart-loading').hide();
          window.location.reload();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }, 2500);
     }
   });
});
jQuery(window).on('click',function(ev){
      if($(ev.target).closest('.yotpo-sr-bottom-line-summary').length) {
        jQuery('.review-tab .collapsibles-wrapper').find('button').addClass('is-open');
        jQuery('.review-tab .collapsibles-wrapper').find('button').attr('aria-expanded',true);
        jQuery('.review-tab .collapsibles-wrapper').find('.collapsible-content').addClass('is-open');
        jQuery('html, body').animate({
              'scrollTop' : (jQuery(".review-tab").position().top-100)
        });
      }
});

jQuery(document).ready(function(){
  if(jQuery('.single_wood_chk').length > 0){
    jQuery('.normal_all_chk').removeClass('hide');
    jQuery('.normal_all_chk').click(function(){
      if(jQuery('.normal_all_chk').hasClass('checked')){
        jQuery('.normal_all_chk').removeClass('checked');
        jQuery('.wood_pro_btn').addClass('hide');
        jQuery('.normal_all_chk').text('Check All');
      }else{
        jQuery('.wood_pro_btn').removeClass('hide');
        jQuery('.normal_all_chk').addClass('checked');
        jQuery('.normal_all_chk').text('UnCheck All');
      }
      var flag='checked';
      if(jQuery('.normal_edit_chk.hide').length==0){
        flag='';
      }
      checkUncheck(flag);
    })
  }else{
    jQuery('.normal_all_chk').addClass('hide');
  }
});
function checkUncheck(flag){
  if(flag==""){
    jQuery('.single_wood_chk').each(function(){
      jQuery(this).prop('checked',true);
    })
  }else{
    jQuery('.single_wood_chk').each(function(){
      jQuery(this).prop('checked',false);
    })
  }
}

function fnHideShowBottleInfo(className){
  jQuery('.bottlesize_fitinfo').hide();
  jQuery('.bs-item').removeClass('active');
  jQuery('.bs-item').removeAttr('aria-current');

  jQuery('#bs-item-' + className).addClass('active');

  jQuery('#bs-item-' + className).attr('aria-current', true);
  jQuery('.'+className).show();
}

//

$(document).ready(function() {
      getHeaderHeight();
  });
  function getHeaderHeight(){
    var heroImageHeight = jQuery('.hero-natural-minh .hero__image-wrapper').outerHeight();
    //console.log("heroImageHeight", heroImageHeight);
    var heroContentHeight = jQuery('.hero-natural-minh .hero__text-wrap .hero__text-content').outerHeight();
    //console.log("heroContentHeight", heroContentHeight);
    var heroHeight = eval(heroImageHeight)+eval(heroContentHeight);
    document.documentElement.style.setProperty('--slider-imageheight', heroImageHeight+'px');
    document.documentElement.style.setProperty('--slider-height', heroHeight+'px');
  }
$(window).on('resize', function () {
      getHeaderHeight();
  })

jQuery(document).ready(function() {
	getToolbarHeight();
});
function getToolbarHeight(){
	var classToolHeight = jQuery('.toolbar-section').height();
	document.documentElement.style.setProperty('--toolbar-height', classToolHeight + 'px');
}
jQuery(window).on('resize', function () {
	getToolbarHeight();
})